export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

export const pageview = () => {
    window.fbq("track", "PageView");
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const pixelEvent = (name, options = {}, eventData = {}) => {


    if(options?.contents){
        options?.contents.map(item => {
            // rename key from product_id to id
            if(item?.product_id){
                item.id = item.product_id;
                delete item.product_id;
            }
        });

    }

    if(options?.event_id){
        eventData.eventID = options.event_id;
        delete options.event_id;
    }

    console.log(`[FBPixel] pixelEvent -> ${name}`,options,eventData);
    window.fbq("track", name, options, eventData);
};